import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  SwapVert as SwapVertIcon,
} from '@mui/icons-material';
import type { TManagerApplicationSortKey } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/types.ts';
import { getManagerSortTooltipTitle } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/utils/utils.ts';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';
import { SortDirection } from '~/modules/covenants/types.ts';

interface IManagerSortableHeaderProps {
  label: string;
  sortKey: TManagerApplicationSortKey;
  activeSortKey: TManagerApplicationSortKey | null;
  direction: SortDirection;
  onToggle: (sortKey: TManagerApplicationSortKey) => void;
}

export const SortableHeader: React.FC<IManagerSortableHeaderProps> = ({
  label,
  sortKey,
  activeSortKey,
  direction,
  onToggle,
}) => {
  const isActive = activeSortKey === sortKey;

  const icon =
    !isActive || direction === SortDirection.None ? (
      <SwapVertIcon fontSize="small" />
    ) : direction === SortDirection.Asc ? (
      <ArrowUpwardIcon fontSize="small" />
    ) : (
      <ArrowDownwardIcon fontSize="small" />
    );

  return (
    <Box sx={managerComponentStyles.sortableHeader}>
      <span>{label}</span>
      <Tooltip title={getManagerSortTooltipTitle(isActive, direction)}>
        <IconButton
          size="small"
          onClick={() => onToggle(sortKey)}
          data-testid={`manager-sort-${sortKey}`}
          sx={managerComponentStyles.sortableHeaderIcon(isActive)}
        >
          {icon}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

